'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
/**
 * attibut interface pour préciser le nom de l'interface (ex: <tl-module-interfacage interface="{{proposition.logicielInterfacage}}")
 */
ngModule.directive("tlModuleInterfacage", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      interface: "@"
    },
    template: "<span tl-tooltip=\"Interfa\xE7age {{interface}}\" class=\"mr-s module-mandatement\">I</span>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/modules/tl-module-interfacage.js
// module id = 2858
// module chunks = 13